import React from 'react';
import { connect } from 'react-redux'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, Button, Breadcrumb, BackTop } from 'antd';
import { PageHeader } from 'components/header';
import { DoubleRightOutlined, PlusOutlined } from '@ant-design/icons';

import { isAuth, _setAxios, getParamTable, getParamTempTableFiltering } from '../../../../lib/Helper';

import AuthRedirect from '../../../../components/AuthRedirect'
import Form from '../modal/Form';
import Delete from '../modal/Delete';
import Filter from '../modal/Filter';
import Desktop from './Desktop';
import Mobile from './Mobile';
import SortingTableDesktopWithFilter from '../../../../components/sorting-table/SortingTableDesktopWithFilter';
import SortingTableMobileWithFilter from '../../../../components/sorting-table/SortingTableMobileWithFilter';
import SearchTable from '../../../../components/search-table/SearchTable';
import RequestApproval from '../modal/RequestApproval';
import Approve from '../modal/Approve';
import Reject from '../modal/Reject';
import Cancel from '../modal/Cancel';
import Return from '../modal/Return';
import Done from '../modal/Done';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}, {
  value: "status",
  label: "Status",
}, {
  value: "tgl_awal",
  label: "Tanggal Awal",
}, {
  value: "tgl_akhir",
  label: "Tanggal Akhir",
}, {
  value: "tk_nama",
  label: "Tendik",
}, {
  value: "lahan_nama",
  label: "Lahan",
}, {
  value: "gedung_nama",
  label: "Gedung",
}, {
  value: "ruangan_nama",
  label: "Ruangan",
}]

class PeminjamanBarang extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {
          // kategori: "Artikel",
        },
      },
      form: {
        data: {},
        visible: false
      },
      delete: {
        data: {},
        visible: false
      },
      filter: {
        values: {
          status: null,
        },
        visible: false,
      },
      requestApproval: {
        data: {},
        visible: false
      },
      approve: {
        data: {},
        visible: false
      },
      reject: {
        data: {},
        visible: false
      },
      cancel: {
        data: {},
        visible: false
      },
      return: {
        data: {},
        visible: false
      },
      done: {
        data: {},
        visible: false
      },
    };
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current
      }
    }
    _setAxios("sarpras/unit/peminjaman/table", "POST", params).then(resp => {

      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }


  // FILTER START ------------------------------------------
  setTempTableFilter = (name, value) => {

    let values = this.state.filter.values
    values[name] = value

    this.setState({
      filter: {
        ...this.state.filter,
        values: values
      }
    })

  };

  setTableFilterFromTemp = () => {
    const params = getParamTempTableFiltering(this.state.table, this.state.filter.values)
    this.fetch(params, isMobile ? true : false)
    this.modalFilter(false)
  };

  modalFilter = (visible = false) => {
    this.setState({
      filter: {
        ...this.state.filter,
        visible: visible,
        values: {
          status: null,
        }
      },
    })
  }
  // FILTER END ------------------------------------------

  modalForm = (visible = false, data = {}) => {
    this.setState({
      form: {
        data: {
          ...data,
          id: data.peminjaman_id,
          ruangan_id: data.ruangan_id ? {
            id: data.ruangan_id,
            nama: data.ruangan_nama
          } : null,
          ruangan_unit_id: data.unit_ruangan_id ? {
            id: data.unit_ruangan_id,
            unit_nama: data.unit_nama,
            keterangan: data.unit_ruangan_nama,
            jml: null
          } : null
        },
        visible: visible
      },
    })
  }

  modalDelete = (visible = false, data = {}) => {
    this.setState({
      delete: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }

  modalRequestApproval = (visible = false, data = {}) => {
    this.setState({
      requestApproval: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }

  modalApprove = (visible = false, data = {}) => {
    this.setState({
      approve: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }

  modalReject = (visible = false, data = {}) => {
    this.setState({
      reject: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }
  modalCancel = (visible = false, data = {}) => {
    this.setState({
      cancel: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }
  modalReturn = (visible = false, data = {}) => {
    this.setState({
      return: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }
  modalDone = (visible = false, data = {}) => {
    this.setState({
      done: {
        data: {
          ...data,
          id: data.peminjaman_id,
        },
        visible: visible
      },
    })
  }

  render() {

    const access = this.props.privilege.access["/sarana-prasarana/peminjaman-barang"]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    const action = access.action
    const { table } = this.state;

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
            <Breadcrumb.Item>Sarana Prasarana</Breadcrumb.Item>
            <Breadcrumb.Item>Peminjaman Barang </Breadcrumb.Item>
          </Breadcrumb>}
          extra={[
            action.create ? <Button type='primary' onClick={this.modalForm.bind(this, true)}><PlusOutlined /> Tambah</Button> : null,
          ]}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          <PageHeader
            className="site-page-header"
            title="Peminjaman Barang"
            subTitle="Data Peminjaman Barang"
          />
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={18} md={19} >
              <SearchTable table={table} fetch={this.fetch} />
            </Col>

            {/* SORTING LIST/TABLE */}
            <Col xs={24} sm={6} md={5}>
              <SortingTableMobileWithFilter isFilter={true} table={table} fetch={this.fetch} modalFilter={this.modalFilter} sortFields={sortFields} />
              <SortingTableDesktopWithFilter table={table} fetch={this.fetch} modalFilter={this.modalFilter} sortFields={sortFields} />
            </Col>

            {/* LIST/TABLE DATA */}
            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalForm={(visible, data) => {
                    this.modalForm(visible, data)
                  }}
                  modalDelete={this.modalDelete}
                  modalRequestApproval={this.modalRequestApproval}
                  modalApprove={this.modalApprove}
                  modalReject={this.modalReject}
                  modalCancel={this.modalCancel}
                  modalReturn={this.modalReturn}
                  modalDone={this.modalDone}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalForm={(visible, data) => {
                    this.modalForm(visible, data)
                  }}
                  modalDelete={this.modalDelete}
                  modalRequestApproval={this.modalRequestApproval}
                  modalApprove={this.modalApprove}
                  modalReject={this.modalReject}
                  modalCancel={this.modalCancel}
                  modalReturn={this.modalReturn}
                  modalDone={this.modalDone}
                />
              </MobileView>
            </Col>

          </Row>
        </div>

        {
          this.state.filter.visible ?
            <Filter
              visible={this.state.filter.visible}
              hideModal={this.modalFilter.bind(this, false)}
              setTempTableFilter={this.setTempTableFilter}
              setTableFilterFromTemp={this.setTableFilterFromTemp}
            /> : ""
        }
        {
          this.state.form.visible ?
            <Form
              data={this.state.form.data}
              visible={this.state.form.visible}
              hideModal={this.modalForm.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.delete.visible ?
            <Delete
              data={this.state.delete.data}
              visible={this.state.delete.visible}
              hideModal={this.modalDelete.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.requestApproval.visible ?
            <RequestApproval
              data={this.state.requestApproval.data}
              visible={this.state.requestApproval.visible}
              hideModal={this.modalRequestApproval.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.approve.visible ?
            <Approve
              data={this.state.approve.data}
              visible={this.state.approve.visible}
              hideModal={this.modalApprove.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.reject.visible ?
            <Reject
              data={this.state.reject.data}
              visible={this.state.reject.visible}
              hideModal={this.modalReject.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.cancel.visible ?
            <Cancel
              data={this.state.cancel.data}
              visible={this.state.cancel.visible}
              hideModal={this.modalCancel.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.return.visible ?
            <Return
              data={this.state.return.data}
              visible={this.state.return.visible}
              hideModal={this.modalReturn.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.done.visible ?
            <Done
              data={this.state.done.data}
              visible={this.state.done.visible}
              hideModal={this.modalDone.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        <BackTop />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(PeminjamanBarang);
